/**
 * FAQ functionality
 *
 * @description This file includes the required functionality for the FAQ ACF Block
 *
 * @return void
 * @access public
 *
 */

import {addEventListenerIfElExists, getClosest} from './helpers';

export const faq = () => {
	const faqToggle = document.querySelectorAll( '.js-faq-toggle' );

	/**
	 * Implement toggle functionality for FAQ Component
	 *
	 * @return void
	 * @since  1.0.0
	 * @access public
	 */
	faqToggle.forEach( function ( element, index ) {

		element.addEventListener( 'click', function ( event ) {
			event.preventDefault();
			const parentItem     = getClosest( event.target, '.c-faq' );
			const activeElements = Array.from( document.querySelectorAll( '.c-faq--open' ) );
			const openFaqClass   = 'c-faq--open';

			if ( parentItem.classList.contains( openFaqClass ) ) {
				activeElements.forEach( node => {
					node.classList.remove( openFaqClass );
					node.querySelector('.c-faq__question').setAttribute("aria-expanded", false );
				} );
				parentItem.classList.remove( openFaqClass );
				element.setAttribute("aria-expanded", false );
			} else {
				activeElements.forEach( node => {
					node.classList.remove( openFaqClass );
					node.querySelector('.c-faq__question').setAttribute("aria-expanded", false );
				} );
				parentItem.classList.add( openFaqClass );
				element.setAttribute("aria-expanded", true );
			}
		} );

	} );
}
